import { FC } from 'react';
import { StyleSheet } from 'react-native';
import { Colors } from '../../themes';
import { Button, ButtonProps } from '../crop-circle/Button';
import { ResetIcon } from '../crop-circle/icons';

type RestartButtonProps = ButtonProps & {
  disabled?: boolean;
};

export const RestartButton: FC<RestartButtonProps> = (
  props: RestartButtonProps
) => {
  const state = props.disabled ? 'warning' : 'active';
  return (
    <Button
      onPress={props.onPress}
      style={StyleSheet.flatten([styles.container, props.style])}
      state={state}
      disabled={props.disabled}
      leftIcon={<ResetIcon color={Colors.white} />}
      {...props}
    >
      {props.children}
    </Button>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 56,
    height: 56,
    minWidth: 56,
    maxHeight: 56,
    borderRadius: 99,
    marginRight: 16,
  },
});
